import { apiSlice } from "../apiSlice"

const API_ORIGIN = new URL(process.env.REACT_APP_SLDL_TESTING_ENVIRONMENT_API_BASE_URL).origin;

export const drivingSchoolService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSingleDrivingSchool: builder.mutation({
      query: ({ drivingSchoolId }) => {
        let url = `${API_ORIGIN}/drivingSchools/${encodeURIComponent(
          drivingSchoolId
        )}`;

        return {
          url,
          method: "GET",
          responseHandler: (response) => response.json(),
        };
      },
    }),

    getAllDrivingSchools: builder.mutation({
      query: () => ({
        url: `${API_ORIGIN}/drivingSchools`,
        method: "GET",
        responseHandler: (response) => response.json(),
      }),
    }),

    addDrivingSchool: builder.mutation({
      query: (data) => ({
        url: `${API_ORIGIN}/drivingSchools`,
        method: "POST",
        body: data,
        responseHandler: (response) => response.text(),
      }),
    }),

    updateDrivingSchool: builder.mutation({
      query: ({ drivingSchoolId, data }) => ({
        url: `${API_ORIGIN}/drivingSchools/${drivingSchoolId}`,
        method: "PUT",
        body: data,
      }),
    }),

    deleteDrivingSchool: builder.mutation({
      query: ({ drivingSchoolId, data }) => ({
        url: `${API_ORIGIN}/drivingSchools/${drivingSchoolId}`,
        method: "DELETE",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetSingleDrivingSchoolMutation,
  useGetAllDrivingSchoolsMutation,
  useAddDrivingSchoolMutation,
  useUpdateDrivingSchoolMutation,
  useDeleteDrivingSchoolMutation,
} = drivingSchoolService;